function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveGrayed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.005 512.005",
    style: {
      enableBackground: "new 0 0 512.005 512.005"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M448.012,64.005h-64c-3.46,0-6.704,1.678-8.704,4.501l-256,362.667  c-1.277,1.802-1.963,3.957-1.963,6.165v64c0,5.891,4.776,10.667,10.667,10.667h320c5.891,0,10.667-4.776,10.667-10.667V74.671  C458.679,68.78,453.903,64.005,448.012,64.005z",
    "data-original": "#B0BEC5",
    className: "",
    "data-old_color": "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M384.012,0.005h-192c-5.891,0-10.667,4.776-10.667,10.667v117.333H64.012  c-5.891,0-10.667,4.776-10.667,10.667v298.667c0,5.891,4.776,10.667,10.667,10.667h320c5.891,0,10.667-4.776,10.667-10.667V10.671  C394.679,4.78,389.903,0.005,384.012,0.005z",
    "data-original": "#CFD8DC",
    className: "",
    "data-old_color": "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.087,0.815c-3.985-1.654-8.574-0.745-11.627,2.304l-128,128  c-4.171,4.16-4.179,10.914-0.019,15.085c2.006,2.011,4.731,3.139,7.571,3.134h128c5.891,0,10.667-4.776,10.667-10.667v-128  C202.678,6.355,200.076,2.464,196.087,0.815z",
    "data-original": "#B0BEC5",
    className: "",
    "data-old_color": "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.012,448.005h-320c-5.891,0-10.667-4.776-10.667-10.667V138.671c-0.005-2.831,1.115-5.548,3.115-7.552l128-128  c2.004-1.999,4.721-3.12,7.552-3.115h192c5.891,0,10.667,4.776,10.667,10.667v426.667  C394.679,443.229,389.903,448.005,384.012,448.005z M74.679,426.671h298.667V21.338H196.428L74.679,143.087V426.671z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#CFCFCF"
    },
    "data-old_color": "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.012,149.338h-128c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667h117.333V10.671  c0-5.891,4.776-10.667,10.667-10.667c5.891,0,10.667,4.776,10.667,10.667v128C202.679,144.562,197.903,149.338,192.012,149.338z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#CFCFCF"
    },
    "data-old_color": "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.012,512.005h-320c-5.891,0-10.667-4.776-10.667-10.667v-64c0-5.891,4.776-10.667,10.667-10.667  c5.891,0,10.667,4.776,10.667,10.667v53.333h298.667V85.338h-53.333c-5.891,0-10.667-4.776-10.667-10.667  s4.776-10.667,10.667-10.667h64c5.891,0,10.667,4.776,10.667,10.667v426.667C458.679,507.229,453.903,512.005,448.012,512.005z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#CFCFCF"
    },
    "data-old_color": "#cfcfcf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveGrayed);
export default __webpack_public_path__ + "static/media/archive-grayed.f6be9c049fd60bcea8d692be498acc8e.svg";
export { ForwardRef as ReactComponent };